import { Injectable, signal } from '@angular/core';

@Injectable()
export class ResizeService {
  private readonly MIN_WIDTH = 350;
  private readonly MAX_WIDTH = 600;
  private readonly DEFAULT_WIDTH = 350;

  private isDraggingInternal = false;
  private startX = 0;
  private startWidth = 0;

  readonly channelsWidth = signal(this.DEFAULT_WIDTH);
  readonly isDragging = signal(false);

  constructor() {
    this.loadSavedWidth();
  }

  startDrag(event: MouseEvent): void {
    this.isDraggingInternal = true;
    this.startX = event.clientX;
    this.startWidth = this.channelsWidth();
    this.isDragging.set(true);

    document.addEventListener('mousemove', this.onMouseMove);
    document.addEventListener('mouseup', this.stopDrag);

    document.body.classList.add('resizing');
    event.preventDefault();
  }

  private onMouseMove = (event: MouseEvent): void => {
    if (!this.isDraggingInternal) return;

    const deltaX = event.clientX - this.startX;
    const newWidth = Math.max(this.MIN_WIDTH, Math.min(this.MAX_WIDTH, this.startWidth + deltaX));

    this.channelsWidth.set(newWidth);
  };

  stopDrag = (): void => {
    if (!this.isDraggingInternal) return;

    this.isDraggingInternal = false;
    this.isDragging.set(false);
    this.saveWidth();

    document.removeEventListener('mousemove', this.onMouseMove);
    document.removeEventListener('mouseup', this.stopDrag);
    document.body.classList.remove('resizing');
  };

  private saveWidth(): void {
    localStorage.setItem('channelsWidth', this.channelsWidth().toString());
  }

  private loadSavedWidth(): void {
    const savedWidth = localStorage.getItem('channelsWidth');
    if (savedWidth) {
      const width = Number(savedWidth);
      if (width >= this.MIN_WIDTH && width <= this.MAX_WIDTH) {
        this.channelsWidth.set(width);
      }
    }
  }

  resetToDefault(): void {
    this.channelsWidth.set(this.DEFAULT_WIDTH);
    this.saveWidth();
  }

  setWidth(width: number): void {
    const clampedWidth = Math.max(this.MIN_WIDTH, Math.min(this.MAX_WIDTH, width));
    this.channelsWidth.set(clampedWidth);
    this.saveWidth();
  }
}
